/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon23Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g
        stroke={"#292929"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        clipPath={"url(#a)"}
      >
        <path
          d={"M15.625 17.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75"}
        ></path>

        <path
          d={
            "M5.625 4.375h7.5a2.5 2.5 0 0 1 0 5h-7.5a3.125 3.125 0 1 0 0 6.25h8.125"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon23Icon;
/* prettier-ignore-end */
